<template>
    <div v-if="format == 'footer'">
    </div>
    <div v-else>
        <a :href="link" target="_blank" class="number">{{number}}</a>
    </div>
</template>

<script>
import { getSiteInfo } from '@/storage/site_info'

export default {
    name: 'Icp',
    data() {
      const siteInfo = getSiteInfo();
        return {
        link: siteInfo.icp.link,
        number: siteInfo.icp.number
        }
    },
    props: {
        format: {
            type: String
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .number {
        color: #999;
    }
</style>
